import React from "react";
import LocalNavSoftLink from "../LocalNavSoftLink";

// All helpers return ONLY link items (no dividers).

export function getManageAccountItems({ wayfarerMode, pwExpired }) {
    if (!wayfarerMode || pwExpired) return [];
    return [
        <LocalNavSoftLink
            key="manage-account"
            id="manage-account"
            destination="/account/preferences"
            text="Manage Account"
        />,
    ];
}

export function getCoreToolsItems() {
    return [
        <LocalNavSoftLink
            key="flow-status"
            id="flow-status"
            destination="/tools/flow-status"
            text="Flow Status"
            feature={["widget-flow-status", "flow"]}
            featureArrayMode="AND"
        />,
        <LocalNavSoftLink
            key="schedule-status"
            id="schedule-status"
            destination="/tools/schedule-status"
            text="Schedule Status"
            feature="widget-schedule-status"
        />,
        <LocalNavSoftLink
            key="activation-schedules-dashboard"
            id="activation-schedules-dashboard"
            destination="/tools/activation-schedules-dashboard"
            text="Activation Schedules Dashboard"
        />,
        <LocalNavSoftLink
            key="calculated-fields"
            id="calculated-fields"
            destination="/tools/calculated-fields"
            text="Calculated Fields"
            feature="calculated-fields"
        />,
        <LocalNavSoftLink
            key="layouts"
            id="layouts"
            destination="/tools/layouts"
            text="Layouts"
            feature="manage-layouts"
        />,
    ];
}

// New section separating monitoring/queue style links from core tools for clarity in navigation.
export function getCountAndDeploymentItems() {
    return [
        <LocalNavSoftLink key="count-log" id="count-log" destination="/tools/count-log" text="Count Log" />,
        <LocalNavSoftLink
            key="deployment-queue"
            id="deployment-queue"
            destination="/tools/flow-deployment-queue"
            text="Deployment Queue"
            feature="flow-deployment-queue"
        />,
    ];
}

export function getDiscoveryAndDataItems({ audienceDiscoverySegmentsName, canSeeAutomation }) {
    const items = [
        <LocalNavSoftLink
            key="discovery-segments"
            id="discovery-segments"
            destination="/tools/discovery-segments"
            text={audienceDiscoverySegmentsName}
            feature="audience-insights-segments"
        />,
        <LocalNavSoftLink
            key="manage-files"
            id="manage-files"
            destination="/tools/manage-files"
            text="Manage Files"
            feature="file-import"
        />,
    ];
    if (canSeeAutomation) {
        items.push(
            <LocalNavSoftLink
                key="manage-automation-items"
                id="manage-automation-items"
                destination="/tools/manage-automation-items"
                text="Manage Automation"
            />
        );
    }
    items.push(<LocalNavSoftLink key="schedules" id="schedules" destination="/tools/schedules" text="Schedules" />);
    items.push(
        <LocalNavSoftLink
            key="data-dashboard"
            id="data-dashboard"
            destination="/tools/data-dashboard"
            text="Data Dashboard"
        />
    );
    items.push(
        <LocalNavSoftLink
            key="model-status"
            id="model-status"
            destination="/tools/model-status"
            text="Model Status"
            feature="modeling"
        />
    );
    return items;
}

export function getVariablesItems({
    hasOfferCodes,
    canManageVariables,
    hasRadiusHidden,
    hasSuperAdmin,
    onOfferCodes,
    onVariables,
    onVariableGroupings,
    onRadiusFilters,
}) {
    const out = [];
    if (hasOfferCodes) {
        out.push(
            <li key="offer-codes-link">
                <a
                    id="offer-codes-link"
                    href="#"
                    onClick={onOfferCodes}
                    style={{ color: "#575755", textDecoration: "none" }}
                >
                    Offer Codes
                </a>
            </li>
        );
    }
    if (canManageVariables) {
        out.push(
            <li key="variables-link">
                <a
                    id="variables-link"
                    href="#"
                    onClick={onVariables}
                    style={{ color: "#575755", textDecoration: "none" }}
                >
                    Variables
                </a>
            </li>
        );
        out.push(
            <li key="variable-groupings-link">
                <a
                    id="variable-groupings-link"
                    href="#"
                    onClick={onVariableGroupings}
                    style={{ color: "#575755", textDecoration: "none" }}
                >
                    Variable Groupings
                </a>
            </li>
        );
    }
    if (hasSuperAdmin) {
        out.push(
            <LocalNavSoftLink
                id="edit-variable-types"
                destination="/tools/variable-types"
                text="Edit Variable Types"
                removeLi={true}
            />
        );
    }
    if (!hasRadiusHidden) {
        out.push(
            <li key="radius-hide">
                <a
                    id="radius-hide"
                    href="#"
                    onClick={onRadiusFilters}
                    style={{ color: "#575755", textDecoration: "none" }}
                >
                    Radius Filters
                </a>
            </li>
        );
    }
    return out;
}

export function getScriptNodeSearchItems({ show, onClick }) {
    if (!show) return [];
    return [
        <li key="script-node-search-link">
            <a
                id="script-node-search-link"
                href="#"
                onClick={onClick}
                style={{ color: "#575755", textDecoration: "none" }}
            >
                Script Node Search
            </a>
        </li>,
    ];
}
